import { render, staticRenderFns } from "./HeaderOrgSwitcher.vue?vue&type=template&id=8418c424&scoped=true&"
import script from "./HeaderOrgSwitcher.vue?vue&type=script&lang=js&"
export * from "./HeaderOrgSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./HeaderOrgSwitcher.vue?vue&type=style&index=0&id=8418c424&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8418c424",
  null
  
)

export default component.exports